<template>
  <div class="discovery-ads-campaign-list">
    <AdBanner
      v-if="mustShowBanner"
      :title="$t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY_BANNER.TITLE')"
      :description="$t('ADVERTISEMENT.CAMPAIGNS.DISCOVERY_BANNER.DESCRIPTION')"
      :image="require('@/assets/images/campaigns/discovery-banner.png')"
    />
    <Card v-else>
      <h4 class="discovery-ads-campaign-list__title">
        {{ $t('ADVERTISEMENT.CAMPAIGNS_LIST.DISCOVERY.TITLE') }}
      </h4>
      <div class="row align-justify">
        <div class="columns large-3 medium-6 small-12">
          <RangeFilter
            v-model="rangeFilter"
            :default-filters="campaignRangeFilters"
            @input="getCampaigns"
          />
        </div>
      </div>
      <CardApiError
        v-if="apiError"
        wrapper-class="campaigns__error-wrapper"
        :error-text="$t('ADVERTISEMENT.CAMPAIGNS.API_ERROR')"
        @retry="getCampaigns"
      />
      <CampaignsList v-else :is-loading="isLoading" :campaigns="campaigns" />
    </Card>
  </div>
</template>

<script>
import AdBanner from '@@/advertisement/common/AdBanner';
import CardApiError from '@@/common/CardApiError';
import Card from '@@/common/Card';
import RangeFilter from '@@/common/RangeFilter';
import CampaignsList from './CampaignsList';
import statsFilter from '@/mixins/statsFilter';
import { campaignTypes } from '../common/constants';

import { DiscoveryAdsCampaigns } from '@/api/api';
import { ALL_TIME } from '@/constant';

export default {
  components: {
    CardApiError,
    CampaignsList,
    Card,
    RangeFilter,
    AdBanner,
  },
  mixins: [statsFilter],
  props: {
    updateController: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rangeFilter: ALL_TIME,
      isLoading: false,
      campaigns: [],
      apiError: false,
    };
  },
  computed: {
    mustShowBanner() {
      const hasAtLeastOneCampaign = this.campaigns.length > 0;
      return !hasAtLeastOneCampaign && !this.isLoading;
    },
    campaignRangeFilters() {
      return [
        {
          value: ALL_TIME,
          label: this.$t('ALL'),
        },
        ...this.getStatsRangeFilters(),
      ];
    },
  },
  created() {
    this.getCampaigns();
    this.updateController.onUpdate(this.checkAndGetCampaigns);
  },
  beforeDestroy() {
    this.updateController.removeOnUpdate(this.checkAndGetCampaigns);
  },
  methods: {
    checkAndGetCampaigns(campaignType) {
      if (campaignType === campaignTypes.DISCOVERY) this.getCampaigns();
    },
    getCampaigns() {
      this.isLoading = true;
      this.apiError = false;
      return DiscoveryAdsCampaigns.getCampaigns(this.rangeFilter)
        .then(campaigns => {
          this.campaigns = campaigns?.map?.(campaign => {
            campaign.remainingBudget = campaign.budget - campaign.spentBudget;
            return campaign;
          });
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
          this.apiError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.discovery-ads-campaign-list {
  &__title {
    margin-bottom: $global-margin * 1.5;
  }
}
</style>
